import axiosInstance from "../../utils/axiosInstance";

export async function chatClient(_requestData) {
  const requestData = {
    ctl: "client",
    act: "chat",
    ..._requestData,
  };
  try {
    const response = await axiosInstance.post("/", requestData);
    return response.data;
  } catch (error) {
    return error;
  }
}
